import { EmployeesService } from './../../../../shared/services/employees/employees.service';
import { UsersService } from './../../../../shared/services/common/users.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';
import { Router } from '@angular/router';
import { Utility } from 'src/app/shared/utility';

@Component({
  selector: 'app-enrollment-info',
  templateUrl: './enrollment-info.component.html',
  styleUrls: ['./enrollment-info.component.css']
})
export class EnrollmentInfoComponent implements OnInit {
  summaryData: any;
  config: any;
  electType = '';
  positionType = '';
  tenMonthEmpType = '';
  jobCode = '';
  isYesSelected: boolean;
  isNoSelected: boolean;
  isYesPositionSelected: boolean;
  isNoPositionSelected: boolean;
  displayload: boolean;
  isSaveButtonDisabled: boolean;
  isUploadVisible: boolean;
  isScheduleSearching: boolean;
  isOldRecord: boolean;
  isTenMonthEmployee: boolean;
  isUploadFileExist: boolean;
  enrollmentInfoForm: FormGroup;
  userLocations: any;
  userSystems: any;
  paySchedulesList: any;
  organizationType: any;
  selectedPayScheduleInfo: any;
  fiscalYear2017: Date;
  selectedFY: Date;
  min = new Date('01/01/1924');
  fileUploadData = [];
  defaultLocation: { name: string; code: string } = {
    name: 'Select...',
    code: ''
  };
  defaultSystem: { description: string; code: string } = {
    description: 'Select...',
    code: ''
  };
  defaultSchedule: { name: string; payScheduleID: number } = {
    name: 'Select...',
    payScheduleID: null
  };
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".pdf", ".tif", ".tiff", ".png", ".docx", ".doc"]
  };
  @Output() goTo = new EventEmitter<object>();

  @Input() set personInfo(wizardData: any) {
    if (wizardData) {
      this.summaryData = wizardData;
      if (wizardData.isEnrollmentInfo) {
        this.setEnrollmentInfo(this.summaryData.wizardData);
      };
    }
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private usersService: UsersService,
    private employeesService: EmployeesService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) {
    this.organizationType = sessionStorage.getItem('orgType');
    this.config = this.readConfigService.getEnrollmentMemberText();
  }

  ngOnInit(): void {
    this.notificationService.setUpLoading(true);
    this.getLoactionAndSystem();
    if (!this.summaryData.isEnrollmentInfo) {
      this.newForm();
    }
  }

  newForm() {
    this.enrollmentInfoForm = this.fb.group({
      employementDate: ['', Validators.required],
      locationCode: ['', Validators.required],
      systemCode: ['', Validators.required],
      paySchedule: ['']
    });
  }

  setEnrollmentInfo(data: any) {
    this.isUploadFileExist = data.enrollmentDetails ? (data.enrollmentDetails.uploadedFileName !== null) : false;
    this.isOldRecord = true;
    const emnrollmentInfo = data.enrollmentDetails;
    this.electType = emnrollmentInfo.electType;
    this.isYesSelected = (this.electType === 'Yes');
    this.isNoSelected = !(this.electType === 'Yes');
    this.positionType = emnrollmentInfo.positionType;
    if (this.positionType === 'Yes') {
      this.isYesPositionSelected = true;
      this.isNoPositionSelected = false;
      if (emnrollmentInfo.jobCode !== 'X' && emnrollmentInfo.jobCode !== '' && emnrollmentInfo.jobCode !== null) {
        const combineJobCode = emnrollmentInfo.systemCode + emnrollmentInfo.jobCode;
        emnrollmentInfo.systemCode = combineJobCode;
      }
      this.newForm();
      this.enrollmentInfoForm.patchValue({
        employementDate: new Date(emnrollmentInfo.enrollmentDate),
        locationCode: emnrollmentInfo.locationCode,
        systemCode: emnrollmentInfo.systemCode,
        paySchedule: emnrollmentInfo.payScheduleId
      });
      const fiscalYear = this.config.minYear;
      this.fiscalYear2017 = new Date(fiscalYear - 1, 6, 1);
      this.selectedFY = Utility.removeTimeFromJSDate(new Date(emnrollmentInfo.enrollmentDate));
      if ((this.organizationType === 'PGU' || this.organizationType === 'QST' || this.organizationType === 'ST') && (this.selectedFY >= this.fiscalYear2017)) {
        if (emnrollmentInfo.locationCode && emnrollmentInfo.systemCode && emnrollmentInfo.enrollmentDate) {
          this.enrollmentInfoForm.controls.paySchedule.setValidators([Validators.required]);
          this.getEnrollmentPayschedule(true);
          if (emnrollmentInfo.systemCode === '7' && emnrollmentInfo.tenMonthEmpType !== '') {
            this.isTenMonthEmployee = true;
            this.tenMonthEmpType = emnrollmentInfo.tenMonthEmpType;
            this.selectedPayScheduleInfo = { contributoryPays: emnrollmentInfo.contributoryPays, totalPays: emnrollmentInfo.totalPays };
          }
        }
      }
      this.isUploadVisible = emnrollmentInfo.systemCode === '6'
        || emnrollmentInfo.systemCode === '9' || emnrollmentInfo.systemCode === '3'
        || emnrollmentInfo.systemCode === '2C';
    } else {
      this.isNoPositionSelected = true;
      this.isYesPositionSelected = false;
    }
  }

  getLoactionAndSystem() {
    const inputData = { userInfo: this.usersService.UserInfo() };
    this.employeesService.getEnrollmentInput(inputData).subscribe((response: any) => {
      if (response && response.success && response.locations && response.locations.length > 0
        && response.systemCodes && response.systemCodes.length > 0) {
        response.locations.forEach(element => {
          element.name = element.code.concat('-', element.name);
        });
        this.userLocations = response.locations.sort((a: any, b: any) => a.code - b.code);
        const orgId = sessionStorage.getItem('orgId');
        if (orgId === '247' && this.summaryData.wizardData.personDetails.isLegislativePlan) {
          this.userSystems = response.systemCodes.filter(ele => ele.code === '5');
        } else {
          this.userSystems = response.systemCodes;
        }
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      })
  }

  saveBtnDisable() {
    return this.enrollmentInfoForm.invalid
      || ((this.isUploadVisible && !this.isUploadFileExist) ? this.fileUploadData.length === 0 : false)
      || (this.isTenMonthEmployee ? this.tenMonthEmpType === '' : false);
  }

  onEmployementDateChange() {
    this.isTenMonthEmployee = false;
    this.tenMonthEmpType = '';
    this.fileUploadData = [];
    const fiscalYear = this.config.minYear;
    this.fiscalYear2017 = new Date(fiscalYear - 1, 6, 1);
    this.selectedFY = this.enrollmentInfoForm.getRawValue().employementDate ? Utility.removeTimeFromJSDate(this.enrollmentInfoForm.getRawValue().employementDate) : null;
    if ((this.organizationType === 'PGU' || this.organizationType === 'QST' || this.organizationType === 'ST') && (this.selectedFY >= this.fiscalYear2017)) {
      if (this.enrollmentInfoForm.getRawValue().employementDate !== ''
        && this.enrollmentInfoForm.getRawValue().employementDate?.getFullYear() > '1924'
        && this.enrollmentInfoForm.getRawValue().locationCode !== ''
        && this.enrollmentInfoForm.getRawValue().systemCode !== '') {
        this.getEnrollmentPayschedule(false);
      } else {
        this.enrollmentInfoForm.patchValue({ paySchedule: null });
        this.enrollmentInfoForm.controls.paySchedule.setValidators([Validators.required]);
        this.enrollmentInfoForm.controls['paySchedule'].disable();
        this.enrollmentInfoForm.get('employementDate').setErrors({ 'invalid': true });
      }
    } else {
      this.isUploadVisible = this.enrollmentInfoForm.getRawValue().systemCode === '6'
        || this.enrollmentInfoForm.getRawValue().systemCode === '9' || this.enrollmentInfoForm.getRawValue().systemCode === '3'
        || this.enrollmentInfoForm.getRawValue().systemCode === '2C';
      this.enrollmentInfoForm.get('paySchedule').setValidators(null);
      this.enrollmentInfoForm.patchValue({ paySchedule: null });
      this.enrollmentInfoForm.controls['paySchedule'].disable();
    }
  }

  selectionChange(value: any, actionFrom: string) {
    this.fileUploadData = [];
    this.isTenMonthEmployee = false;
    this.tenMonthEmpType = '';
    if (actionFrom === 'location') {
      this.enrollmentInfoForm.patchValue({ locationCode: value.code });
    } else {
      this.enrollmentInfoForm.patchValue({ systemCode: value.code });
    }
    const fiscalYear = this.config.minYear;
    this.fiscalYear2017 = new Date(fiscalYear - 1, 6, 1);
    if (this.enrollmentInfoForm.getRawValue().employementDate !== ''
      && this.enrollmentInfoForm.getRawValue().employementDate?.getFullYear() > '1924') {
      this.selectedFY = Utility.removeTimeFromJSDate(this.enrollmentInfoForm.getRawValue().employementDate);
    }
    if ((this.organizationType === 'PGU' || this.organizationType === 'QST' || this.organizationType === 'ST') && (this.selectedFY >= this.fiscalYear2017)) {
      if (this.enrollmentInfoForm.getRawValue().employementDate !== ''
        && this.enrollmentInfoForm.getRawValue().employementDate?.getFullYear() > '1924'
        && this.enrollmentInfoForm.getRawValue().locationCode !== ''
        && this.enrollmentInfoForm.getRawValue().systemCode !== '') {
        this.getEnrollmentPayschedule(false);
      } else {
        this.enrollmentInfoForm.controls.paySchedule.setValidators([Validators.required]);
        this.enrollmentInfoForm.controls['paySchedule'].disable();
      }
    } else {
      this.isUploadVisible = this.enrollmentInfoForm.getRawValue().systemCode === '6'
        || this.enrollmentInfoForm.getRawValue().systemCode === '9' || this.enrollmentInfoForm.getRawValue().systemCode === '3'
        || this.enrollmentInfoForm.getRawValue().systemCode === '2C';
      this.enrollmentInfoForm.get('paySchedule').setValidators(null);
      this.enrollmentInfoForm.patchValue({ paySchedule: null });
      this.enrollmentInfoForm.controls['paySchedule'].disable();
    }
  }

  selectionPaySchedule(value: any) {
    if (value) {
      this.enrollmentInfoForm.patchValue({ paySchedule: value.payScheduleID });
      this.enrollmentInfoForm.get('employementDate').setErrors(null);
      this.selectedPayScheduleInfo = value;
      this.isUploadVisible = this.enrollmentInfoForm.getRawValue().systemCode === '6'
        || this.enrollmentInfoForm.getRawValue().systemCode === '9' || this.enrollmentInfoForm.getRawValue().systemCode === '3'
        || this.enrollmentInfoForm.getRawValue().systemCode === '2C';
      const firstCondition = parseInt(this.enrollmentInfoForm.getRawValue().locationCode.substring(0, 4)) > this.config.FirstFourLocationCode
        && this.config.Position3and4LocationCode.includes(this.enrollmentInfoForm.getRawValue().locationCode.substring(2, 4));
      const secondCondition = this.config.StateFirstFourLocationCode.includes(this.enrollmentInfoForm.getRawValue().locationCode.substring(0, 4));
      const totalPayCondition = this.config.TotalNumberOfPay.includes(value?.totalPays?.toString());
      if (this.enrollmentInfoForm.getRawValue().systemCode === '7' && (firstCondition || secondCondition) && totalPayCondition) {
        this.isTenMonthEmployee = true;
        this.tenMonthEmpType = '';
      } else {
        this.isTenMonthEmployee = false;
      }
    }
  }

  getEnrollmentPayschedule(isExistingRecord: boolean) {
    this.paySchedulesList = [];
    this.isUploadVisible = false;
    if (!isExistingRecord) { this.enrollmentInfoForm.patchValue({ paySchedule: null }); }
    this.isScheduleSearching = true;
    const summaryDetails = this.summaryData.wizardData;
    const inputData = {
      userInfo: this.usersService.UserInfo(), ssn: summaryDetails.ssn,
      locationCode: isExistingRecord ? summaryDetails.enrollmentDetails.locationCode : this.enrollmentInfoForm.getRawValue().locationCode,
      systemCode: isExistingRecord ? summaryDetails.enrollmentDetails.systemCode : this.enrollmentInfoForm.getRawValue().systemCode,
      enrollmentDate: isExistingRecord ? summaryDetails.enrollmentDetails.enrollmentDate : this.enrollmentInfoForm.getRawValue().employementDate
    };
    this.employeesService.getEnrollmentPayschedule(inputData).subscribe((response: any) => {
      if (response && response.success) {
        if (response.data && response.data.length > 0) {
          const concatDate = response.data.map(item => ({ ...item, originalName: item.name, name: `${item.payScheduleID}-${item.name}` }));
          if (this.organizationType === 'ST' && (this.enrollmentInfoForm.getRawValue().systemCode === '4' || this.enrollmentInfoForm.getRawValue().systemCode === '5')) {
            this.paySchedulesList = concatDate.filter(item => item.originalName === this.config.PayScheduleForState[2].name);
          } else if (this.organizationType === 'ST' && this.enrollmentInfoForm.getRawValue().locationCode.startsWith('3602')) {
            this.paySchedulesList = concatDate.filter(item => item.originalName === this.config.PayScheduleForState[1].name);
          } else if (this.organizationType === 'ST') {
            this.paySchedulesList = concatDate.filter(item => item.originalName === this.config.PayScheduleForState[0].name);
          } else {
            this.paySchedulesList = concatDate;
          }
        } else {
          this.paySchedulesList = [];
          this.notificationService.setUpNotification({ message: 'No Schedule found', success: true });
        }
        this.enrollmentInfoForm.controls.paySchedule.setValidators([Validators.required]);
        this.enrollmentInfoForm.controls['paySchedule'].enable();
      } else {
        this.notificationService.setErrorNotification();
      }
      this.isScheduleSearching = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.isScheduleSearching = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  onEnrollInfoChange() {
    if (this.electType === 'Yes') {
      this.isYesSelected = true;
      this.isNoSelected = false;
    } else {
      this.isNoSelected = true;
      this.isYesSelected = false;
    }
    this.positionType = '';
    this.tenMonthEmpType = '';
    this.isNoPositionSelected = false;
    this.isYesPositionSelected = false;
    this.newForm();
  }

  onPositionInfoChange() {
    if (this.positionType === 'Yes') {
      this.isYesPositionSelected = true;
      this.isNoPositionSelected = false;
      this.newForm();
      if (this.organizationType === 'PGU' || this.organizationType === 'QST' || this.organizationType === 'ST') {
        this.enrollmentInfoForm.controls.paySchedule.setValidators([Validators.required]);
        this.enrollmentInfoForm.controls['paySchedule'].disable();
        const orgId = sessionStorage.getItem('orgId');
        if (orgId === '247' && this.summaryData.wizardData.personDetails.isLegislativePlan) {
          this.enrollmentInfoForm.patchValue({ systemCode: '5' });
        }
      }
      this.isSaveButtonDisabled = true;
    } else {
      this.isNoPositionSelected = true;
      this.isYesPositionSelected = false;
    }
    this.isTenMonthEmployee = false;
    this.tenMonthEmpType = '';
  }

  onTenMonthEmpInfoChange() {
    this.jobCode = this.tenMonthEmpType === 'Yes' ? 'X' : '';
  }

  onSelectEvent(e: SelectEvent, upload) {
    if (e && e.files && e.files.length > 0) {
      this.fileUploadData = e.files;
      this.scrollIntoView();
    }
  }

  scrollIntoView() {
    document.getElementById('save-btn').scrollIntoView();
  }

  onRemoveEvent(e: any) {
    this.fileUploadData = [];
  }

  goToContactInfo(option: number) {
    this.displayload = true;
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      enrollmentInfo: {
        id: this.isOldRecord ? this.summaryData.wizardData.enrollmentDetails.id : 0,
        locationCode: this.enrollmentInfoForm.getRawValue().locationCode,
        systemCode: this.enrollmentInfoForm.getRawValue().systemCode.length > 1 ? this.enrollmentInfoForm.getRawValue().systemCode.slice(0, 1) : this.enrollmentInfoForm.getRawValue().systemCode,
        enrollmentDate: Utility.formatDate(this.enrollmentInfoForm.getRawValue().employementDate),
        enrollmentsId: this.summaryData.wizardData.enrollmentsId,
        payScheduleId: this.enrollmentInfoForm.getRawValue().paySchedule,
        electType: this.electType,
        positionType: this.positionType,
        tenMonthEmpType: this.tenMonthEmpType,
        jobCode: this.enrollmentInfoForm.getRawValue().systemCode.length > 1 ? this.enrollmentInfoForm.getRawValue().systemCode.slice(1, 2) : this.jobCode,
        contributoryPays: this.selectedPayScheduleInfo?.contributoryPays,
        totalPays: this.selectedPayScheduleInfo?.totalPays
      },
      uploadedFile: (this.enrollmentInfoForm.getRawValue().systemCode === '6' || this.enrollmentInfoForm.getRawValue().systemCode === '9' || this.enrollmentInfoForm.getRawValue().systemCode === '3'
        || this.enrollmentInfoForm.getRawValue().systemCode === '2C') ? this.fileUploadData[0] : null,
      fileName: this.fileUploadData[0] ? null : this.summaryData.wizardData?.enrollmentDetails?.uploadedFileName
    };
    this.employeesService.saveEnrollmentInfo(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.notificationService.setUpNotification({ message: response.message, success: true });
        inputData.enrollmentInfo.id = response.id;
        inputData.enrollmentInfo['uploadedFileName'] = inputData.fileName ? inputData?.fileName : inputData?.uploadedFile?.name;
        this.goTo.emit({
          option, isFinalSubmit: false, isContactInfo: true, wizardData: {
            personDetails: this.summaryData.wizardData.personDetails, ssn: this.summaryData.wizardData.ssn,
            empSSN: this.summaryData.wizardData.empSSN, enrollmentDetails: inputData.enrollmentInfo,
            enrollmentsId: response.enrollmentsId, contactDetails: this.isOldRecord ? this.summaryData.wizardData.contactDetails : null
          }
        });
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.displayload = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.displayload = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  goToPreviousPage(option: number) {
    this.next(option);
  }

  startNewEnrollment(option: number) {
    this.next(option);
  }

  next(option: number) {
    this.goTo.emit({
      option, isFinalSubmit: false, wizardData: {
        personDetails: this.summaryData.wizardData.personDetails, ssn: this.summaryData.wizardData.ssn,
        empSSN: this.summaryData.wizardData.empSSN, enrollmentsId: this.summaryData.wizardData.enrollmentsId
      }
    });
  }

  downloadUploadedFile(data: any) {
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      id: data.wizardData.enrollmentDetails.id,
      type: 'enrollment',
      fileName: data.wizardData.enrollmentDetails.uploadedFileName
    };
    this.employeesService.downloadUploadedFile(inputData).subscribe(() => {
      data.docClicked = !data.docClicked;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        data.docClicked = !data.docClicked;
      });
  }
}
